define('TescoMobile_Customer/js/view/account/bill-caps',['uiComponent', 'jquery', 'mage/translate', 'Magento_Ui/js/modal/modal', 'Magento_Catalog/js/price-utils'], function (Component, $, $t, modal, priceUtils) {
  'use strict';

  return Component.extend({
    initialize: function () {
      var currentSku = $('input[name=current_bill_cap]').val();
      this._super();
      let billCapPopupThreshold = parseInt(this.billCapPopupThreshold);
      var cancelledConsent = false;
      var modalOptions = {
        modalClass: 'billcap-prompt',
        title: $t('Confirm your safety buffer'),
        clickableOverlay: false,
        type: 'popup'
      };
      let popup = modal(modalOptions, $('#bill-cap-modal'));
      $('.bill-cap-amount-options input:radio').click(function () {
        let selectedBillCapElement = $('input[name="bill_cap"]:checked');
        let selectedBillCapValue = $('input#bill_cap_value_' + selectedBillCapElement.val()).val();
        let selectedBillCapUnlimited = parseInt($('input#bill_cap_unlimited_' + selectedBillCapElement.val()).val());
        if (selectedBillCapUnlimited) {
          $('#dashboard-modal-safety-buffer-value').text($t('an unlimited amount'));
          $('.customer-bill-cap-info .safety-buffer-note').text($t('You\'ve decided not to cap your bill. This means you could run up large bills for anything that\'s not included in your allowance.'));
        } else {
          $('#dashboard-modal-safety-buffer-value').text($t('more than') + ' ' + priceUtils.formatPrice(selectedBillCapValue));
          if (selectedBillCapValue > 0) {
            $('.customer-bill-cap-info .safety-buffer-note').html($t('A <strong class="safety-buffer-value"></strong> safety buffer means you won\'t ever spend more than <strong class="safety-buffer-value"></strong> extra a month should change as per the value selected.'));
          } else {
            $('.customer-bill-cap-info .safety-buffer-note').html($t('A <strong class="safety-buffer-value"></strong> safety buffer means you can\'t use any data, minutes or texts outside your allowance.You won\'t be able to call or text premium rate numbers or do anything else chargeable.'));
          }
        }
        $('.customer-bill-cap-start-options-info').hide();
        $('.start-options-wrapper.active').removeClass('active').hide();
        $('#submit-bill-cap-update').prop('disabled', true);
        if (selectedBillCapElement.val() !== currentSku) {
          let activeStartOptionsSelector = '#start-options-wrapper-' + selectedBillCapElement.val();
          $('.customer-bill-cap-start-options-info').show();
          $('.safety-buffer-value').text(priceUtils.formatPrice(selectedBillCapValue));
          $('.start-options-wrapper.active').removeClass('active').hide();
          $(activeStartOptionsSelector).addClass('active').show();
          $(activeStartOptionsSelector + ' input:radio').click(function () {
            $('#submit-bill-cap-update').prop('disabled', false);
          });
          if ($(activeStartOptionsSelector + ' input:radio:checked').length) {
            $('#submit-bill-cap-update').prop('disabled', false);
          }
        } else {
          $('.safety-buffer-value').text(priceUtils.formatPrice(selectedBillCapValue));
        }
        if ($('input#bill_cap_value_' + selectedBillCapElement.val()).val() > billCapPopupThreshold) {
          $("#bill-cap-modal").modal("openModal");
        }
      });
      $("#submit-bill-cap-update").click(function () {
        $(this).trigger('processStart');
      });
      $("#bill-cap-modal-confirm-button").click(function () {
        $("#bill-cap-modal").modal("closeModal");
      });
      $("#bill-cap-modal-cancel-button, .action-close").click(function () {
        cancelledConsent = true;
        $("#bill-cap-modal-confirmation-checkbox").prop('checked', false);
        $('#bill-cap-modal-confirm-button').prop('disabled', true);
        $('#submit-bill-cap-update').prop('disabled', true);
        $("#bill-cap-modal").modal("closeModal");
      });
      $(".bill-cap-start-options").click(function () {
        if (cancelledConsent && $('input#bill_cap_value_' + $('input[name="bill_cap"]:checked').val()).val() > billCapPopupThreshold) {
          $("#bill-cap-modal").modal("openModal");
        }
      });
      $("#bill-cap-modal-confirmation-checkbox").click(function (event) {
        $('#bill-cap-modal-confirm-button').prop('disabled', !$('#' + event.currentTarget.id + ':checked').length);
        cancelledConsent = false;
      });
    }
  });
});

